import React, { useMemo } from 'react';
import styles from './text.module.css';
import useInterpolation from '#/hooks/use-interpolation.js';

export default function Text({ desc, children }) {
  const interpolate = useInterpolation();
  let { content, className } = desc;

  const [html, text] = useMemo(() => {
    return [interpolate(content), interpolate(children)];
  }, [content, children, interpolate]);

  if (html) {
    return (
      <div
        id={desc.id}
        dangerouslySetInnerHTML={{ __html: html }}
        className={`${styles.textWidget} ${className ?? ''}`}
      />
    );
  }

  return (
    <div id={desc.id} className={`${styles.textWidget} ${className ?? ''}`}>
      {text}
    </div>
  );
}
